import { useIntl } from 'react-intl';
import { useLocation, useNavigate, useRouteError } from 'react-router';
import Page from 'client/components/aria/Page/Page';
import ErrorMessage from 'client/utils/routes/ErrorMessage/ErrorMessage';

import PropTypes from 'prop-types';
import { CONTACT_PAGE, CONTACT_PAGE_SIGNED_OUT } from '../routeConstants';
import { USER_PROFILE_NOT_FOUND } from 'client/utils/constants/errors';
import useAuth from 'client/utils/auth/useAuth';
import { useEffect } from 'react';

const ErrorBoundary = ({ error }) => {
    const intl = useIntl();
    const routeError = useRouteError();
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (error?.statusCode === 404 && error?.message === USER_PROFILE_NOT_FOUND.message) {
            if (user) {
                navigate('/');
            }
        }
    }, [error, user]);

    if (routeError?.errorCode === 'interaction_in_progress') {
        // TODO: work out why MSAL throws this (bug: #10428)
        //  But for now, just suppress the message while we redirect.
        // eslint-disable-next-line no-console
        console.error(routeError);
        return null;
    }

    const currentError = error || routeError || {};
    const errorCode = currentError.statusCode || 404;
    const errorMessage = currentError.message;

    const isContactPage = location.pathname === CONTACT_PAGE || location.pathname === CONTACT_PAGE_SIGNED_OUT;
    return (
        <Page
            data-testid="errorPage"
            title={intl.formatMessage({ id: 'errorPage.title' })}
        >
            <div className="govuk-grid-row">
                <div data-testid={errorCode} className="govuk-grid-column-full">
                    <ErrorMessage
                        code={errorCode}
                        message={errorMessage}
                    />

                    {isContactPage
                        ? <div className='govuk-inset-text' data-testid={'cmsFallbackMessage'}>
                            <ErrorMessage id='errorPage.serviceDeskFallback.email' />
                            <br /><br />
                            <ErrorMessage id='errorPage.serviceDeskFallback.phone' />
                        </div>
                        : <></>}
                </div>
            </div>
        </Page>

    );
};

ErrorBoundary.propTypes = {
    error: PropTypes.object
};

export default ErrorBoundary;
